import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { InputWithEmoji } from '../../../../../../../common/components/InputWithEmoji/InputWithEmoji';
import CheckBox from '../../../../../../../common/components/Checkbox';
import ChatbotModel, { MessagesSettings } from '@mm/state/model/ChatbotModel';
import { useValidationMessageCRUDActions } from '@mm/state/actions/ValidationMessageCRUDActions';

const INPUT_LABEL = 'Message sent when a contact enters an invalid email';
const INPUT_PLACEHOLDER = 'Please enter a valid email address';

type Props = {
  bot: ChatbotModel;
  onBotChange: (bot: ChatbotModel) => void;
};

export const InvalidEmail = ({ bot, onBotChange }: Props) => {
  const validation = get(bot, 'validationMessages.email');
  const { update, create } = useValidationMessageCRUDActions();

  const [validationBody, setValidationBody] = useState('');
  useEffect(() => setValidationBody(validation.body), [validation]);

  const updateBody = () => {
    if (validationBody === validation.body) {
      return;
    }
    const updatedValidation = { ...validation, body: validationBody };

    const action = updatedValidation.id ? update : create;
    action(updatedValidation);
  };

  const onChangeCheckbox = () => {
    const messagesSettings = bot.messagesSettings || {
      disableEmailValidation: false,
    };

    messagesSettings.disableEmailValidation =
      !messagesSettings.disableEmailValidation;

    onBotChange({
      ...bot,
      messagesSettings: messagesSettings as MessagesSettings,
    });
  };

  return (
    <div>
      <div className="bot-publishing-pane__logo-item-subtext">
        <CheckBox
          isChecked={!get(bot, 'messagesSettings.disableEmailValidation')}
          label={INPUT_LABEL}
          className="bot-system-messages__checkbox"
          onToggle={onChangeCheckbox}
        />
      </div>
      <InputWithEmoji
        placeholder={INPUT_PLACEHOLDER}
        maxLength={100}
        value={validationBody}
        onChange={setValidationBody}
        onBlur={updateBody}
        disabled={!!get(bot, 'messagesSettings.disableEmailValidation')}
      />
    </div>
  );
};
